export const sources = {
};
export const img = {
	src: "__VITE_ASSET__LphhLScmzwPqWwTyAbd7ig__",
	w: 128,
	h: 128
};
export default {
	sources: sources,
	img: img
};
